import { Component, OnInit, Inject, inject } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { Router, ActivatedRoute } from "@angular/router";
import { StandardService } from "../services/standard.service";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { StandardTypeEnum, StandardListType, AddendumStatusEnum } from "../core/constant";
import { CryptographyService } from "../services/cryptography.service";
import { LocationService } from "../services/location.service";
import { SelectedStandard } from "../models/selected-standard";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SelectedStandardDetail } from "../models/selected-standard-detail";
declare var $: any;
import { DatePipe } from "@angular/common";
import DOMPurify from "dompurify";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-view-all-upcoming-standard-detail-view",
  templateUrl: "./view-all-upcoming-standard-detail-view.component.html",
  styleUrls: ["./view-all-upcoming-standard-detail-view.component.scss"],
  providers: [DatePipe],
})
export class ViewAllUpcomingStandardDetailViewComponent implements OnInit {
  private _snackBar = inject(MatSnackBar);
  allLocations: string = '';
  subLocations: string = '';
  keyContactEmail: string = '';
  links: any[] = [];
  createdOn: Date;
  detailsExpanded = false;
  additionalInfoExpanded = false;
  loading: boolean = false;
  gapLoading: boolean = true;

  grsDetail2: any;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      '<img src="/assets/images/back.svg">',
      '<img src="/assets/images/next.svg">',
    ],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    nav: true,
  };
  grsId: number = 0;
  grsDetail: SelectedStandard = new SelectedStandard();
  error: string = "";
  userRole: number;
  notes: SafeHtml = "";
  additionalInformation: SafeHtml = "";
  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  get keyContactEmailResolved(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.email ||
      d?.keyContact?.Email ||
      d?.standard?.keyContact?.email ||
      d?.standard?.keyContact?.Email ||
      d?.standard?.email ||
      d?.standard?.Email ||
      d?.email ||
      d?.Email ||
      this.keyContactEmail ||
      ""
    );
  }

  get linksList(): any[] {
    const d = this.grsDetail as any;
    const rawLinks = d?.links || d?.standard?.links || d?.Links || d?.standard?.Links || d?.resourceLinks1 || [];
    if (!Array.isArray(rawLinks)) return [];
    return rawLinks.map((l: any) => ({
      url: l?.url || l?.Url || "",
      title: l?.title || l?.Title || l?.url || l?.Url || ""
    })).filter(l => !!l.url?.trim() || !!l.title?.trim());
  }

  // Partly in effect: exactly one of the two dates is still in the future
  // and the other is already current/past - the standard already applies
  // to one restaurant type but not the other yet.
  private get partlyInEffectDates(): { effectiveFrom: Date; newRestaurantsEffectiveFrom: Date } | null {
    const standard = this.grsDetail?.standard as any;
    if (!standard?.effectiveFrom || !standard?.newRestaurantsEffectiveFrom) {
      return null;
    }
    const effectiveFrom = new Date(standard.effectiveFrom);
    const newRestaurantsEffectiveFrom = new Date(standard.newRestaurantsEffectiveFrom);
    if (isNaN(effectiveFrom.getTime()) || isNaN(newRestaurantsEffectiveFrom.getTime())) {
      return null;
    }
    return { effectiveFrom, newRestaurantsEffectiveFrom };
  }

  get isPartlyInEffect(): boolean {
    const dates = this.partlyInEffectDates;
    if (!dates) return false;
    const now = new Date();
    const effectiveFromIsFuture = dates.effectiveFrom > now;
    const newRestaurantsEffectiveFromIsFuture = dates.newRestaurantsEffectiveFrom > now;
    return effectiveFromIsFuture !== newRestaurantsEffectiveFromIsFuture;
  }

  get partlyInEffectMessage(): string {
    const dates = this.partlyInEffectDates;
    if (!dates) return "";
    const now = new Date();
    if (dates.effectiveFrom > now) {
      return `Already in effect for new restaurants. Applies to existing restaurants from ${this.datePipe.transform(dates.effectiveFrom, "d MMMM, yyyy")}.`;
    }
    return `Already in effect for existing restaurants. Applies to new restaurants from ${this.datePipe.transform(dates.newRestaurantsEffectiveFrom, "d MMMM, yyyy")}.`;
  }

  get hardwareDescription(): string {
    const d = this.grsDetail as any;
    return (
      d?.keyContact?.emailDescription ||
      d?.keyContact?.EmailDescription ||
      d?.standard?.keyContact?.emailDescription ||
      d?.standard?.keyContact?.EmailDescription ||
      d?.standard?.emailDescription ||
      d?.standard?.EmailDescription ||
      d?.emailDescription ||
      d?.EmailDescription ||
      d?.keyContactDesc ||
      d?.standard?.keyContactDesc ||
      ""
    );
  }

  constructor(
    private activeRoute: ActivatedRoute,
    private standardService: StandardService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private router: Router,
    private cryptographyService: CryptographyService,
    public locationService: LocationService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
  ) {
    this.grsId = parseInt(this.activeRoute.snapshot.paramMap.get("grsId"));
  }

  ngOnInit() {
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole"),
    );
    this.getDetailByGrbesId(this.grsId);
    $(document).ready(() => {
      let objId;
      $(".image-map area")
        .mouseenter(function (e) {
          objId = $(this).attr("target");
          $(".main-image").css("opacity", "0");
          $(".main-image").css("z-index", "9999");
          $(objId).find("img").css("z-index", "2");
          $(objId).removeClass("d-none");
          $(objId).addClass("active");
          $(".chunk").removeClass("d-none");
          $(".tooltip-text span").text($(this).attr("alt"));
          $(".tooltip-text").css("left", e.pageX + 2);
          $(".tooltip-text").css("top", e.pageY + 2);
          $(".tooltip-text").fadeIn("slow");
        })
        .mouseleave(function (e) {
          $(".main-image").css("z-index", "1");
          $(".chunk").addClass("d-none");
          $(".chunk").removeClass("active");
          $(".main-image").css("opacity", "1");
        });
    });
  }
  getDetailByGrbesId(grsId: number) {
    // this.gapLoading = true;
    this.loading = true;
    this.standardService
      .getGrbesDetailInfomationByStandardId(
        grsId,
        this.cryptographyService.decryptData(this.storage.get("countryId")),
        this.standardService.upcomingStandardFiltration.filterSet,
        StandardListType.Upcoming,
        null,
      )
      .subscribe((data: any) => {
        //debugger;
        this.grsDetail = data;
        this.links = data.links?.length ? data.links : (data.standard?.links || []);
        this.keyContactEmail = data.keyContact?.email || data.standard?.keyContact?.email || '';
        this.allLocations = this.grsDetail.standard.standardLocation
          .map((loc) => loc.locationType.name)
          .join(", ");
        this.subLocations = this.grsDetail.standard.standardLocation
          .map((loc) =>
            loc.locationType.subLocationTypes?.length
              ? loc.locationType.subLocationTypes.map((sloc) => sloc.name).join(", ")
              : "",
          )
          .filter(Boolean)
          .join(", ");

        this.grsDetail2 = new SelectedStandardDetail(data);
        void 0;
        const cleanNotes = DOMPurify.sanitize(this.grsDetail.standard.note);
        this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);
        const cleanAddInfo = DOMPurify.sanitize(
          this.grsDetail.standard.additionalInformation,
        );
        this.additionalInformation =
          this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);
        // this.notes = this.sanitizer.bypassSecurityTrustHtml(
        //   this.grsDetail.standard.note
        // );

        // this.additionalInformation = this.sanitizer.bypassSecurityTrustHtml(
        //   this.grsDetail.standard.additionalInformation
        // );
        this.loading = false;
        this.gapLoading = false;
        () => {
          this.loading = false;
          this.gapLoading = false;
        };
      });
  }

  navigateAccToType(type, id) {
    if (type == 4) {
      this.router.navigate(["/minimum-standard-detail-view/" + id]);
      return;
    }
    if (type == 8) {
      this.router.navigate(["/operations-standards-detail-view/" + id]);
      return;
    }
    if (type == 0) {
      this.router.navigate(["/view-equipments-standard-detail/" + id]);
      return;
    }
    if (type == 1 || type == 2) {
      this.router.navigate(["/global-recommendations-detail-view/" + id]);
      return;
    }
  }
  slide(grsID: number, isForward: boolean) {
    //debugger;
    this.loading = true;
    this.gapLoading = true;
    if (this.userRole != 2) {
      this.standardService
        .getNextPreviousGrsInfomationByCurrentStandardId(
          grsID,
          isForward,
          this.cryptographyService.decryptData(this.storage.get("countryId")),
          this.standardService.upcomingStandardFiltration.filterSet,
          StandardListType.Upcoming,
        )
        .subscribe((data: SelectedStandard) => {
          if (
            data.standard.standardTypeId ==
            this.standardTypeEnum.GlobalEquipmentStandard
          ) {
            this.router.navigate([
              "/view-upcoming-equipments-standard-detail/" + data.standard.id,
            ]);
          }
          this.router.navigate([
            "view-upcoming-standard-detail",
            data.standard.id,
          ]);
          this.grsDetail = data;
          this.links = (data as any).links?.length ? (data as any).links : (data.standard?.links || []);
          this.keyContactEmail = (data as any).keyContact?.email || data.standard?.keyContact?.email || '';
          const cleanNotes = DOMPurify.sanitize(this.grsDetail.standard.note);
          this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);
          const cleanAddInfo = DOMPurify.sanitize(
            this.grsDetail.standard.additionalInformation,
          );
          this.additionalInformation =
            this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);
          // this.notes = this.sanitizer.bypassSecurityTrustHtml(
          //   this.grsDetail.standard.note
          // );
          // this.additionalInformation = this.sanitizer.bypassSecurityTrustHtml(
          //   this.grsDetail.standard.additionalInformation
          // );
          this.loading = false;
          this.gapLoading = false;
          (error: string) => {
            this.error = error;
            this.loading = false;
          };
        });
    } else {
      this.standardService
        .getNextPreviousGrsInfomationByCurrentStandardId(
          grsID,
          isForward,
          this.cryptographyService.decryptData(this.storage.get("countryId")),
          this.standardService.upcomingStandardFiltration.filterSet,
          StandardListType.Upcoming,
        )
        .subscribe((data: SelectedStandard) => {
          if (
            data.standard.standardTypeId ==
            this.standardTypeEnum.GlobalEquipmentStandard
          ) {
            this.router.navigate([
              "/view-upcoming-equipments-standard-detail/" + data.standard.id,
            ]);
          }
          this.router.navigate([
            "view-upcoming-standard-detail",
            data.standard.id,
          ]);
          this.grsDetail = new SelectedStandard(data);
          this.links = (data as any).links?.length ? (data as any).links : (data.standard?.links || []);
          this.keyContactEmail = (data as any).keyContact?.email || data.standard?.keyContact?.email || '';
          const cleanNotes = DOMPurify.sanitize(this.grsDetail.standard.note);
          this.notes = this.sanitizer.bypassSecurityTrustHtml(cleanNotes);
          const cleanAddInfo = DOMPurify.sanitize(
            this.grsDetail.standard.additionalInformation,
          );
          this.additionalInformation =
            this.sanitizer.bypassSecurityTrustHtml(cleanAddInfo);
          // this.notes = this.sanitizer.bypassSecurityTrustHtml(
          //   this.grsDetail.standard.note
          // );
          // this.additionalInformation = this.sanitizer.bypassSecurityTrustHtml(
          //   this.grsDetail.standard.additionalInformation
          // );
          this.loading = false;
          this.gapLoading = false;
          (error: string) => {
            this.error = error;
            this.loading = false;
          };
        });
    }
  }
  getAddendumStatusLabel(addendumStatusId: number): string {
    switch (addendumStatusId) {
      case AddendumStatusEnum.Approved:
        return "Approved";
      case AddendumStatusEnum.Rejected:
        return "Rejected";
      case AddendumStatusEnum.Expired:
        return "Expired";
      case AddendumStatusEnum.Requested:
        return "Requested";
      default:
        return "Pending";
    }
  }

  downloadExcel() {
    this.standardService.downloadSingleStandardExcel(
      this.grsDetail,
      "upcoming",
    );
    return;
  }

  isShareModalOpen = false;
  shareModalTitle = "";
  shareModalSubtitle = "";
  shareModalUrl = "";

  openShareModal(): void {
    const standard = (this.grsDetail as any)?.standard;
    this.shareModalTitle = standard?.title || "";
    this.shareModalSubtitle = [
      standard?.standardType?.name,
      standard?.category?.name,
    ]
      .filter(Boolean)
      .join(" · ");
    this.shareModalUrl = window.location.href;
    this.isShareModalOpen = true;
  }

  openSnackBar() {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 2 * 1000,
      data: {
        message: "Object Copied to clipboard!",
      },
    });
  }

  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }
  toggleDetails2() {
    this.additionalInfoExpanded = !this.additionalInfoExpanded;
  }

  copyText(content: any) {
    void 0;
    navigator.clipboard.writeText(content);
    this.openSnackBar();
  }

  getDetails() {
    return this.sanitizer.bypassSecurityTrustHtml(this.grsDetail.standard.note);
  }
  getAdditionalInfo() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.grsDetail.standard.additionalInformation,
    );
  }
  goBack() {
    this.router.navigate(["/view-all-upcoming-standards-list"]);
  }
}
